import React, { useEffect, useState } from "react";
import { ItemWithMetaData } from "../api/Items";
import { GlobeAmericasIcon } from "@heroicons/react/24/outline";
import { useGetTranslations } from "../api/ItemsApi";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { classNames } from "../utils";
import LANGUAGE_MAP from "../utils/language-dict";

type Props = {
  item: ItemWithMetaData;
  isSummary?: boolean;
};

const PostArticleTranslation = ({ item, isSummary = false }: Props) => {
  const {
    mutate: getTranslations,
    isLoading: isLoadingTranslations,
    error: errorTranslations,
    data: translations,
  } = useGetTranslations();
  const [showTranslation, setShowTranslation] = useState(false);
  const [originalText, setOriginalText] = useState("");
  function loadOriginalText() {
    setShowTranslation(true);
    getTranslations(item.item.external_id);
  }

  useEffect(() => {
    if (translations && translations.length > 0) {
      setOriginalText(translations[0].original.text);
    }
  }, [translations]);

  function getLanguageLabel(language: string) {
    return LANGUAGE_MAP[language] ?? language;
  }

  return (
    <div className="text-gray-500 flex flex-col gap-3">
      {item.translation && !isLoadingTranslations && (
        <div className="flex gap-3  mt-3 mb-2">
          <GlobeAmericasIcon className="w-4 text-green-500" />
          <span className="text-xs">
            Translated from {getLanguageLabel(item.translation?.language)}
          </span>
          {!showTranslation && (
            <span
              className={classNames(
                "text-xs cursor-pointer",
                isSummary ? "text-green-500" : "underline"
              )}
              onClick={loadOriginalText}
            >
              Show Original language
            </span>
          )}
          {showTranslation && (
            <div
              className={classNames(
                "text-xs cursor-pointer",
                isSummary ? "text-orange-500" : "underline"
              )}
              onClick={() => setShowTranslation(false)}
            >
              Hide Original language
            </div>
          )}
        </div>
      )}
      {isLoadingTranslations && <LoadingSpinner />}
      {showTranslation && !isLoadingTranslations && (
        <div className="flex flex-col gap-3 mb-2">
          <div className="text-xs">{originalText}</div>
        </div>
      )}
      {errorTranslations && (
        <div className="text-red-500">
          Error loading translations, please try again later
        </div>
      )}
    </div>
  );
};
export default PostArticleTranslation;
